export enum FilterTabsEnum {
    LOBBY = 'LOBBY',
    SLOTS = 'SLOTS',
    LIVE_CASINO = 'LIVE_CASINO',
    TABLE_GAMES = 'TABLE_GAMES',
    POPULAR = 'POPULAR',
}
